import { render } from "./PolicyPreviewPage.vue?vue&type=template&id=116e2d1a&scoped=true"
import script from "./PolicyPreviewPage.vue?vue&type=script&lang=js"
export * from "./PolicyPreviewPage.vue?vue&type=script&lang=js"

import "./PolicyPreviewPage.vue?vue&type=style&index=0&id=116e2d1a&scoped=true&lang=css"

import exportComponent from "/go/src/bitbucket.org/VertexSecurity/core_vuejs/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-116e2d1a"]])

export default __exports__